import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

export const ProductsPopContainer = styled.div`
  background-color: ${({ theme }) => theme.COLORS.background};
`;

export const InnerBox = styled.div`
  padding: 80px 0;

  ${MEDIA_QUERIES.mdUp} {
    padding: 80px ${SPACER.xlarge};
    justify-content: space-between;
  }

  ${MEDIA_QUERIES.xlUp} {
    display: flex;
    align-items: center;
    max-width: 1296px;
    padding: 100px 72px;
    margin: auto;
    gap: ${SPACER.xlarge};
  }

  ${MEDIA_QUERIES.xxlUp} {
    padding: 120px 0;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: ${SPACER.x5large};

  ${MEDIA_QUERIES.xlUp} {
    display: block;
    max-width: 460px;
    margin: 0;
  }
`;

export const Summary = styled.div`
  ${MEDIA_QUERIES.mdUp} {
    max-width: 400px;
  }

  ${MEDIA_QUERIES.xlUp} {
    max-width: unset;
  }
`;

export const Title = styled.h2`
  font-size: 32px;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.64px;
  margin: 0 ${SPACER.medium} ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    font-size: 32px;
    margin: 0 0 ${SPACER.large};
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 52px;
  }
`;

export const Subtitle = styled.p`
  font-size: 16px;
  line-height: 132%;
  margin: 0 ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    margin: 0;
  }

  ${MEDIA_QUERIES.xlUp} {
    display: block;
    font-size: 24px;
    line-height: 140%;
    max-width: unset;
    margin: 0 0 ${SPACER.medium};
    // margin: 0 0 130px;
  }
`;

export const DesktopDisclaimer = styled.small`
  display: none;
  font-size: 14px;
  line-height: 140%;
  margin-top: ${SPACER.x3large};

  ${MEDIA_QUERIES.xlUp} {
    display: block;
  }
`;

export const MobileDisclaimer = styled.small`
  font-size: 14px;
  line-height: 140%;
  margin: 0 ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    margin: 0;
  }

  ${MEDIA_QUERIES.xlUp} {
    display: none;
  }
`;

export const ProductsContainer = styled.ul`
  display: flex;
  overflow: auto;
  padding: 0 ${SPACER.medium} ${SPACER.medium};
  margin-bottom: ${SPACER.x5large};
  align-self: flex-start;
  gap: ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    overflow: visible;
    padding: 0;
    gap: ${SPACER.xlarge};
  }

  ${MEDIA_QUERIES.xlUp} {
    margin: 0;
  }
`;

export const desktopCtaStyles = css`
  ${desktopOnly()}
  font-size: 16px;
  font-weight: 700;
  line-height: 132%;
  letter-spacing: -0.32px;

  button {
    width: fit-content;
  }

  small {
    font-weight: 400;
    margin-top: ${SPACER.small};
  }

  ${MEDIA_QUERIES.mdUp} {
    width: fit-content;
    margin-left: auto;
  }

  ${MEDIA_QUERIES.xlUp} {
    margin: 0;
  }
`;

export const mobileCtaStyles = css`
  ${mobileOnly()}
  margin-bottom: ${SPACER.x5large};
`;
